<template>
  <div class="home">
    <nav>
      <div>
        <select v-model="locale">
          <option value="en-US">English</option>
          <option value="fr-FR">French</option>
          <option value="ar-AE">Arabic</option>
        </select>
      </div>
    </nav>
    <h1>{{t('greet')}}</h1>
  </div>
</template>

<script lang="ts" setup>

import { useI18n } from 'vue-i18n';
const {t, locale} = useI18n({useScope: 'global'})
</script>
